// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2AZTk","colMaxWidth":"Table_colMaxWidth__1IFID"};